import { render, staticRenderFns } from "./InputSection.vue?vue&type=template&id=3fc2cd50&scoped=true"
import script from "./InputSection.vue?vue&type=script&lang=js"
export * from "./InputSection.vue?vue&type=script&lang=js"
import style0 from "./InputSection.vue?vue&type=style&index=0&id=3fc2cd50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc2cd50",
  null
  
)

export default component.exports